import { observer } from 'mobx-react';
import { useDependencies } from '@servicetitan/react-ioc';
import { OrgHub } from 'org-hub-shared';

import { Header } from './header/Header';
import { AuthStore } from '../stores/auth.store';
import { AuthModule } from '../../auth/AuthModule';
import { NoAccessModule } from '../../auth/NoAccessModule';

export const Shell = observer(() => {
    const [authStore] = useDependencies(AuthStore);

    if (authStore.accessDenied) {
        return <NoAccessModule />;
    }

    if (!authStore.isAuthenticated) {
        return <AuthModule />;
    }

    return (
        <div className="shell">
            <Header />
            <OrgHub rootOrgId={authStore.user?.rootOrgId ?? null} />
        </div>
    );
});
